export const isV2Enabled = (envVariable) => {
  return String(process.env[envVariable]).trim() === 'true';
};
